const numberFilters = (href: string): number => {
  const url = new URL(href);

  const numberSegments = url.pathname.split('/');

  if (numberSegments.length > 2) {
    return url.searchParams.size + 1;
  }

  return url.searchParams.size;
};

export default numberFilters;
